import ajax, { handleRedirect } from 'helpers/ajax';
import Routes from 'apps/portal/routes.erb';
import { handleRejectedRequest } from 'helpers/form';
import { fieldsLabels } from './components/sign-in-form/validate';

export function submit(payload) {
  return () => ajax({
    url: Routes.identity_session_path({ format: 'json' }),
    method: 'POST',
    data: { identity: payload },
  }, null, {
    hideDefaultErrorNotification: true,
    ignoreAuthError: true,
  }).then(handleRedirect)
    .catch(handleRejectedRequest(fieldsLabels));
}
